__webpack_require__.p = "https://bmidxbaustriaplprod.netlify.app/";